/** Shared theme tokens for participant assessment chrome (nav, guides, pillar strip). */

export function assessmentChromeTokens(dark, primaryColor = null) {
  const brand = primaryColor || (dark ? "#38bdf8" : "#004f73");
  if (dark) {
    return {
      dark: true,
      page: "linear-gradient(135deg,#04080f 0%,#070e1c 55%,#05111f 100%)",
      pageDots: "radial-gradient(rgba(255,255,255,0.04) 1px,transparent 1px)",
      nav: "rgba(4,8,15,0.92)",
      navBorder: "rgba(255,255,255,0.07)",
      card: "rgba(255,255,255,0.055)",
      cardBorder: "rgba(255,255,255,0.09)",
      helpBg: "rgba(255,255,255,0.04)",
      helpBorder: "rgba(255,255,255,0.08)",
      text1: "#fff",
      text2: "rgba(255,255,255,0.60)",
      text3: "rgba(255,255,255,0.30)",
      brand,
      pillarBg: "rgba(0,79,115,0.20)",
      pillarBorder: "rgba(56,189,248,0.20)",
      pillarColor: "rgba(103,232,249,0.85)",
      stripBg: "rgba(4,8,15,0.30)",
      stripBgSoft: "rgba(4,8,15,0.18)",
      guideBg: "rgba(3,9,20,0.94)",
      guideToggleBg: "rgba(0,79,115,0.08)",
      contentCard: "rgba(255,255,255,0.045)",
      contentBorder: "rgba(255,255,255,0.1)",
      primaryBtn:
        "linear-gradient(105deg,#67e8f9 0%,#1a9bb8 55%,#004f73 100%)",
      primaryBtnText: "#041018",
      ghostBtnBorder: "rgba(255,255,255,0.18)",
      ghostBtnText: "rgba(255,255,255,0.85)",
      chipBg: "rgba(255,255,255,0.06)",
      chipBorder: "rgba(255,255,255,0.12)",
      progressTrack: "rgba(255,255,255,0.08)",
      completeBg: "rgba(74,222,128,0.13)",
      completeBorder: "rgba(74,222,128,0.30)",
      completeColor: "#4ade80",
      incompleteBg: "rgba(255,255,255,0.05)",
      incompleteBorder: "rgba(255,255,255,0.09)",
      incompleteColor: "rgba(255,255,255,0.45)",
      meterEmpty: "rgba(255,255,255,0.10)",
      meterFill: "#38bdf8",
      dotActive: {
        bg: "#004f73",
        border: "#38bdf8",
        color: "#fff",
        shadow: "0 0 0 3px rgba(56,189,248,0.22)",
      },
      dotAnswered: {
        bg: "rgba(0,79,115,0.28)",
        border: "rgba(56,189,248,0.35)",
        color: "#38bdf8",
      },
      dotEmpty: {
        bg: "rgba(255,255,255,0.04)",
        border: "rgba(255,255,255,0.10)",
        color: "rgba(255,255,255,0.28)",
      },
    };
  }
  return {
    dark: false,
    page: "linear-gradient(135deg,#f0f4f8 0%,#f8fafc 55%,#edf2f7 100%)",
    pageDots: "radial-gradient(rgba(0,79,115,0.07) 1px,transparent 1px)",
    nav: "rgba(255,255,255,0.95)",
    navBorder: "rgba(0,79,115,0.09)",
    card: "#ffffff",
    cardBorder: "rgba(0,79,115,0.11)",
    helpBg: "#f8fafc",
    helpBorder: "rgba(0,79,115,0.09)",
    text1: "#0f172a",
    text2: "#475569",
    text3: "#94a3b8",
      brand,
      pillarBg: "rgba(0,79,115,0.07)",
    pillarBorder: "rgba(0,79,115,0.15)",
    pillarColor: "#004f73",
    stripBg: "rgba(255,255,255,0.35)",
    stripBgSoft: "rgba(255,255,255,0.22)",
    guideBg: "#f7f9fc",
    guideToggleBg: "rgba(0,79,115,0.035)",
    contentCard: "#ffffff",
    contentBorder: "rgba(0,79,115,0.11)",
      primaryBtn: `linear-gradient(105deg,${brand} 0%,#105a7c 45%,#1a7fa8 100%)`,
      primaryBtnText: "#ffffff",
      ghostBtnBorder: "rgba(0,79,115,0.22)",
      ghostBtnText: brand,
    chipBg: "rgba(0,79,115,0.06)",
    chipBorder: "rgba(0,79,115,0.14)",
    progressTrack: "rgba(0,79,115,0.08)",
    completeBg: "rgba(22,163,74,0.08)",
    completeBorder: "rgba(22,163,74,0.22)",
    completeColor: "#16a34a",
    incompleteBg: "rgba(0,79,115,0.05)",
    incompleteBorder: "rgba(0,79,115,0.12)",
    incompleteColor: "rgba(0,79,115,0.55)",
    meterEmpty: "rgba(0,79,115,0.12)",
      meterFill: brand,
      dotActive: {
        bg: brand,
        border: brand,
        color: "#fff",
        shadow: "0 0 0 3px rgba(0,79,115,0.18)",
      },
      dotAnswered: {
        bg: "rgba(0,79,115,0.12)",
        border: "rgba(0,79,115,0.28)",
        color: brand,
      },
    dotEmpty: { bg: "#fff", border: "#e2e8f0", color: "#94a3b8" },
  };
}
